export function convertHex(hexCode,opacity){
  var hex = hexCode.replace('#','');

  if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  var r = parseInt(hex.substring(0,2), 16),
      g = parseInt(hex.substring(2,4), 16),
      b = parseInt(hex.substring(4,6), 16);

  return 'rgba('+r+','+g+','+b+','+opacity/100+')';
}

/**
* ECMA2016 / ES6
*/
export const convertHexToRGBA = (hexCode, opacity) => {
  if (!hexCode) {
    // Générer une couleur hexadécimale aléatoire si hexCode est absent
    hexCode = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
  }

  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }    

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity / 100})`;
};